
<template>
  <m-layout>
    <div fill-height class="fill-height" style="max-width:100%; position:relative">
      <v-card-title class="m-page__title">
        <span class="headline">Help</span>
      </v-card-title>

      </div>
  </m-layout>
</template>
<script>
export default {
  data () {
    return {
    };
  },
  methods: {
    eventClick: function (e) {
      console.log('event clicked', e);
    },
    getData () {

    }
  }
};
</script>
<style lang="scss">
</style>
